import { render, staticRenderFns } from "./PosOptions.template.vue?vue&type=template&id=46251ee3&scoped=true&"
var script = {}
import style0 from "./PosOptions.template.vue?vue&type=style&index=0&id=46251ee3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46251ee3",
  null
  
)

export default component.exports